import { ILink } from '../../types/ILink';
import { Api } from './BaseApi'

const LinkApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getLinks: build.query<ILink[], void>({
            query: () => `Link/My`,
            providesTags: ["GetMyLinks"],
        }),
        createLink: build.mutation<void, ILink>({
            query: (newLink) => ({
                url: `Link`,
                method: "POST",
                body: newLink
            }),
            invalidatesTags: ["GetMyLinks"],
        }),
        updateLink: build.mutation<void, ILink>({
            query: (link) => ({
                url: `Link/${link.Link_Id}`,
                method: "PUT",
                body: link
            }),
            invalidatesTags: ["GetMyLinks"],
        }),
        deleteLink: build.mutation<void, number>({
            query: (id) => ({
                url: `Link/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["GetMyLinks"]
        }),
    }),
    overrideExisting: false,
})

export { LinkApi };